
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";
import { MarketplaceFilters } from "./types";
import {
  mapRiskWillingnessToLevel,
  determineExchange,
} from "@/components/marketplace/utils/marketplace-utils";

export const useUserResponsesLoader = (
  setFilters: React.Dispatch<React.SetStateAction<MarketplaceFilters>>
) => {
  const { toast } = useToast();

  const loadUserResponses = async () => {
    try {
      const { data: userResponse, error } = await supabase
        .from("user_responses")
        .select("*")
        .order("created_at", { ascending: false })
        .limit(1)
        .single();

      if (error) {
        console.error("Error fetching user responses:", error);
        return;
      }

      console.log("User response loaded:", userResponse);

      if (userResponse) {
        let minInvestment = "all";
        if (userResponse.investment_amount >= 2500) minInvestment = "2500";
        else if (userResponse.investment_amount >= 1000) minInvestment = "1000";
        else if (userResponse.investment_amount >= 500) minInvestment = "500";
        else if (userResponse.investment_amount >= 100) minInvestment = "100";

        const riskLevel = mapRiskWillingnessToLevel(userResponse.risk_willingness);
        const exchanges = determineExchange(userResponse.crypto_preferences);

        console.log("User responses available but not automatically applying filters:", {
          minInvestment,
          riskLevel,
          exchanges,
        });

        // Note: We're not automatically setting the filters anymore
        // The function is still available but needs to be explicitly called
      }
    } catch (err) {
      console.error("Error in loadUserResponses:", err);
    }
  };

  return { loadUserResponses };
};

